<template>
  <div class="groups-selector pt-2 pl-2 pr-2 w-75">
    <div class="row">
      <div class="col-4 col-xl-2">
        <group-selector
          :groups="coverageGroups"
          :selected="selectedGroup"
          class="pointer-events-all"
        />
      </div>
      <div class="col-8 col-xl-10">
        <layer-selector
          :layer-options="groupLayers"
          class="pointer-events-all"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus';
import GroupSelector from '@/components/CoverageLayer/GroupSelector.vue';
import LayerSelector from '@/components/CoverageLayer/LayerSelector.vue';

export default {
  components: {
    GroupSelector,
    LayerSelector,
  },
  computed: {
    coverageGroups() {
      return this.layerData.map((v) => v.group);
    },
    groupLayers() {
      return (!this.selectedGroup)
        ? []
        : this.layerData
          .find((covLayer) => covLayer.group === this.selectedGroup)
          .layers
          .sort((a, b) => a.priority - b.priority);
    },
  },
  name: 'CoverageLayerSelector',
  data() {
    return {
      layerData: this.layers,
      selectedGroup: null,
    };
  },
  destroyed() {
    EventBus.$off('coverageGroupSelected');
  },
  methods: {
    onGroupChanged(group) {
      this.selectedGroup = group;
    },
  },
  mounted() {
    EventBus.$on('coverageGroupSelected', this.onGroupChanged);
  },
  props: {
    layers: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    layers(val) {
      this.layerData = val;
      if (val.length) {
        this.selectedGroup = val[0].group;
      }
    },
  },
};
</script>

<style scoped>
.groups-selector{
  left: 50%;
  transform: translate(-50%,0);
  background-color: #fff;
}
.groups-selector > div.input-group{
  cursor: auto;
}
.pointer-events-all{
  pointer-events: all;
}
</style>
